import React, { forwardRef } from 'react';
import { ButtonText } from '../typography';
import { StyledTabButton } from './styled';
export const Tab = forwardRef(function Tab({ children, onClick, onActivate, active, ...props }, ref) {
    const handleClickTab = (event) => {
        if (event) {
            event.preventDefault();
        }
        if (onClick) {
            onClick(event);
        }
        if (onActivate) {
            onActivate();
        }
    };
    return (React.createElement(StyledTabButton, { ref: ref, type: "button", role: "tab", onClick: handleClickTab, "$active": active, ...props },
        React.createElement(ButtonText, null, children)));
});
